<template>
  <div id="receive">
    <br>
    <h5 class="left bold">
      รายการส่งตรวจ
    </h5>
    <br>
    <div class="right">
      <!--            <button type="button" class="btn btn-success" @click="goAdd()">-->
      <!--                เพิ่มรายการ-->
      <!--            </button>-->
    </div>
    <br>
    <receive-table :alert-input="alertInput" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ReceiveTable from "../../components/Receive/ReceiveTable.vue";
export default {
    components: { ReceiveTable },
  props: {
    alertInput: {
      default: false
    }
  },
    data() {
        return {};
    },
  created() {
    // this.setStatus()
  },
  methods: {
    ...mapActions({
      'setStatus': 'Status/setAll'
    })
  },
};
</script>

<style scoped>
#receive {
    width: 95vw;
    margin: 0 auto;
}
.left {
    text-align: left;
}
.right {
    text-align: right;
}
.bold {
    font-weight: bold;
}
</style>
